<div class="l-wrapper">
  <app-header></app-header>
  <div class="l-main">
    <img class="c-pc" src="./../../../../assets/img/main.png" alt="" />
    <img class="c-sp" src="./../../../../assets/img/main-sp.png" alt="" />
  </div>
  <div class="l-top">
    <div class="l-top__img c-pc">
      <img src="./../../../../assets/img/top-main.png" alt="" />
    </div>
    <div class="l-top__description">
      <h2 translate class="l-top__description__title">
        {{ "top.content1.title" }}
      </h2>
      <img src="./../../../../assets/img/border.png" alt="" class="c-pc" />
      <div class="l-top__description__content">
        <p translate class="c-top__content">
          {{ "top.content1.description.1" }}
        </p>
        <p translate class="c-top__content">
          {{ "top.content1.description.2" }}
        </p>
        <p translate class="c-top__content">
          {{ "top.content1.description.3" }}
        </p>
        <p translate class="c-top__content">
          {{ "top.content1.description.4" }}
        </p>
      </div>
    </div>
  </div>
  <div class="l-link">
    <div class="l-link__content">
      <a [href]="'/service' + getUrl()">
        <img src="./../../../../assets/img/top_service.png" alt="" />
        <div class="l-link__content__text">
          <p translate>{{ "top.link.title1" }}</p>
          <img src="./../../../../assets/img/right.png" alt="" />
        </div>
      </a>
    </div>
    <div class="l-link__content">
      <a [href]="'/about' + getUrl()">
        <img src="./../../../../assets/img/top_company.png" alt="" />
        <div class="l-link__content__text">
          <p translate>{{ "top.link.title2" }}</p>
          <img src="./../../../../assets/img/right.png" alt="" />
        </div>
      </a>
    </div>
  </div>
  <app-footer></app-footer>
</div>
